const messages = {
  "pt_BR": {
    "home_salutation": "Bem vindo à Alexa Bolada!",
  }
}

export default messages
